<template>
  <AResult
    :title="props.title"
    :sub-title="props.subTitle"
    :status="props.status"
  >
    <template #icon v-if="isHaveIconSlot">
      <slot name="icon" />
    </template>

    <template #extra v-if="isHaveExtraSlot">
      <slot name="extra" />
    </template>

    <template #default v-if="isHaveDefaultSlot">
      <slot name="reason" />
    </template>
  </AResult>
</template>

<script lang="ts">
export default {};
</script>

<script setup lang="ts">
import {computed, useSlots} from 'vue';
import {Result as AResult} from 'ant-design-vue';

import type {EAntResultStatus} from '@/assets/ant/result/enums';

interface IProps {
  title?: string;
  subTitle?: string;

  status?: EAntResultStatus;
}

const slots = useSlots();
const props = defineProps<IProps>();

const isHaveIconSlot = computed(() => slots.icon != null);
const isHaveExtraSlot = computed(() => slots.extra != null);
const isHaveDefaultSlot = computed(() => slots.default != null);
</script>

<style lang="scss" />
